

import { initialLoadingProps } from 'types/interfaces';
import { SET_LOADING } from './actions';

const initialState: initialLoadingProps = {
  on: false
};

export interface LoadingReducerActionProps {
  type: string;
  payload: initialLoadingProps;
}

const LoadingReducer = (state = initialState, action: LoadingReducerActionProps) => {
  switch (action.type) {
    case SET_LOADING: {
      return {
        ...state,
        on: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default LoadingReducer;
